export default __webpack_public_path__ + "static/media/buy-guitar.01da1cdc.jpg";